const Results = (results) => {
    const view = results.posts
        .map((result) => {
            return `
        <div class="col-md-6 col-xl-4 result ${result['result-flip']}">
        <div class="result-item same-result-height">
        <div class="result-item__front">
        <div class="result-item__front-inner">
        <div class="result-type">${result['result-type']}</div>
        <div class="result-taxonomy">
            ${result['result-category']}
        </div>
        <div class="result-title">${result['result-amount']}</div>
        <div class="result-subtitle">${result['result-description']}</div>
        </div>
        </div>
        <div class="result-item__back same-result-height d-flex align-items-center justify-content-center">
        <div class="result-description">
        ${result['result-content']}
        </div>
        </div>
        </div>
        </div>
        `;
        })
        .join('');
    return view;
};

export default Results;